module.exports = "<p>\n  performance-sponsors works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-sponsors/performance-sponsors.component.html
// module id = ./src/app/routes/performance/performance-sponsors/performance-sponsors.component.html
// module chunks = 9